import { initializeApp } from 'firebase/app';
import { getFirestore, collection, getDocs } from 'firebase/firestore/lite';
import { getAuth, signInWithCustomToken, signInWithEmailAndPassword, User } from "firebase/auth";
import { getStorage } from "firebase/storage";
import { getAnalytics } from "firebase/analytics";

const firebaseConfig = {
  apiKey: process.env.REACT_APP_FIREBASE_APIKEY,
  authDomain: process.env.REACT_APP_FIREBASE_DOMAIN,
  databaseURL: process.env.REACT_APP_FIREBASE_DATABASE,
  projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID,
  storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: process.env.REACT_APP_FIREBASE_SENDER_ID,
  appId: process.env.REACT_APP_FIREBASE_APP_ID,
  measurementId: process.env.REACT_APP_FIREBASE_MEASUREMENT_ID,
};

const app = initializeApp(firebaseConfig);

export const db = getFirestore(app)
export const auth = getAuth(app)
export const customTokenSignIn = signInWithCustomToken
export const emailAndPasswordSignIn = signInWithEmailAndPassword
export const storage = getStorage(app)
export const analytics = getAnalytics(app)

// Firebase Authentication API Token取得
export const getFirebaseAuthToken = async (isRefresh: boolean = true) => {
  let user = auth.currentUser;
  if (!user) {
    // リロード時に認証情報が消えてしまうので、再認証を行う
    user = await initFirebaseAuth();
  }

  if (user) {
    return await user.getIdToken(/* forceRefresh */ isRefresh);
  } else {
    console.error("Firebase authentication failed: user is null.");
    return undefined;
  }
};

// Firebaseユーザー情報取得
export const getFirebaseUserInfo = (): any => {
  return auth.currentUser !== null ? auth.currentUser : {};
};

// Firebaseログイン判定
export const isFirebaseAuth = (): any => {
  return auth.currentUser !== null;
};

// 既存のCustom Claimsを確認（キャッシュ済みトークンを使用、ネットワーク不要）
export const hasCustomClaims = async (): Promise<boolean> => {
  const user = auth.currentUser;
  if (!user) return false;
  try {
    const result = await user.getIdTokenResult(false);
    const claims = result.claims as any;
    return !!(claims.tenpo_codes && Array.isArray(claims.tenpo_codes) && claims.tenpo_codes.length > 0);
  } catch {
    return false;
  }
};

// Firebase認証
export const initFirebaseAuth = (): Promise<User | null> => {
  return new Promise((resolve) => {
    var unSub = auth.onAuthStateChanged((user) => {
      // user オブジェクトを resolve
      resolve(user);
      unSub();
    });
  });
};
